import React from 'react'
import PropTypes from 'prop-types'
import { Avatar, Chip, SvgIcon } from '@mui/material'
import { get } from 'lodash'
import { useTheme } from '@mui/material/styles'
import { ReactComponent as ContainerIcon } from 'assets/Container.svg'
import { ALPHA_38_PERCENT } from 'theme/colors'

const ContainersChip = ({ label, clickable = false, ...rest }) => {
  const theme = useTheme()
  const size = get(rest, 'size', 'medium')
  const isMediumSize = size === 'medium'
  const variant = get(rest, 'variant', 'filled')
  return (
    <Chip
      avatar={
        <Avatar sx={{ backgroundColor: `${theme.palette.background.black}${ALPHA_38_PERCENT}` }}>
          <SvgIcon sx={{ fontSize: isMediumSize ? '1.1rem' : 14, color: theme.palette.common.white }} inheritViewBox>
            <ContainerIcon />
          </SvgIcon>
        </Avatar>
      }
      variant={variant}
      clickable={clickable}
      label={label}
      {...rest}
    />
  )
}

ContainersChip.propTypes = {
  action: PropTypes.string,
  label: PropTypes.string,
  clickable: PropTypes.bool,
}

export default ContainersChip
